export const PREDEFINED_RANGES_MAP = {
	TODAY: 'today',
	LAST_TWO_DAYS: 'lastTwoDays',
	YESTERDAY: 'yesterday',
	THIS_WEEK: 'thisWeek',
	PREVIOUS_WEEK: 'previousWeek',
	LAST_SEVEN_DAYS: 'lastSevenDays',
	THIS_MONTH: 'thisMonth',
	PREVIOUS_MONTH: 'previousMonth',
	LAST_THIRTY_DAYS: 'lastThirtyDays',
	THIS_QUARTER: 'thisQuarter',
	PREVIOUS_QUARTER: 'previousQuarter',
	LAST_NINETY_DAYS: 'lastNinetyDays',
	THIS_YEAR: 'thisYear',
}
